import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService, LoginType } from "@shared/services/auth.service";
import { LocalStorageService } from "ngx-webstorage";
import { environment } from "src/environments/environment";
import { isSafeRedirectPath } from "../utils/redirect-path.util";

export function AuthGuard(shouldBeAuthenticated: boolean): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

        const authService: AuthService = inject(AuthService);
        const router = inject(Router);
        const localStorageService = inject(LocalStorageService);
        
        const queryParams = route.queryParams;
        
        if (queryParams['clearLogin']) {

            const qp = { ...queryParams };

            delete qp['clearLogin'];

            authService.authenticated = false;
            localStorageService.clear('session_token');

            authService.doctorViewAuthenticated = false;
            localStorageService.clear('doctor_view_session_token');

            return router.createUrlTree([`/`], { queryParams: qp });
        }

        let type: LoginType = 'companyPersonnel';
        
        if (queryParams['redirectPath']?.includes('doctor-view')) {
            type = 'doctorView';
        }
    
        const isAuthenticated = type === 'doctorView' ? authService.doctorViewAuthenticated : authService.authenticated;
    
        if (shouldBeAuthenticated) {
            
            if (!isAuthenticated) {
                return router.createUrlTree([`/`], { queryParams });
            }

            if (type === 'doctorView') {
                const redirectPath = queryParams['redirectPath'];

                if (isSafeRedirectPath(redirectPath, environment.baseSiteUrl, environment.name)) {
                    window.location.href = `${redirectPath}?doctorViewToken=${localStorageService.retrieve('doctor_view_session_token') ?? ''}`;
                    return false;
                }

                return router.createUrlTree(['/platforms']);
            } else {
                return true;
            }
            
        } else {

            if (isAuthenticated) {

                if (type === 'doctorView') {
                    const redirectPath = queryParams['redirectPath'];

                    if (isSafeRedirectPath(redirectPath, environment.baseSiteUrl, environment.name)) {
                        window.location.href = `${redirectPath}?doctorViewToken=${localStorageService.retrieve('doctor_view_session_token') ?? ''}`;
                        return false;
                    }

                    return router.createUrlTree(['/platforms']);
                } else {
                    return router.createUrlTree([`/platforms`], { queryParams });
                }

            }

            return true;
        }

    };
}
